import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Field, reduxForm, FieldArray, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { renderField } from "../../Utils/renderField";
import { validate, validators } from "validate-redux-form";
import {
    SelectField,
    renderRichTextArea,
    renderFilePicker,
    renderMap,
} from "../../Utils/renderField/renderField";
import renderVehicles from "./Vehicles";
import renderPacients from "./Pacients";
import renderContactPerson from "./ContactPerson";
import {
    required,
    requiredField,
    validateWhiteSpace,
} from "../../../../utility/validation";
import { change, untouch } from "redux-form";
import { ROLE_CABIN_ATTENDANT } from "../../../../utility/constants";
import Swal from "sweetalert2";

const Form = (props) => {
    const {
        handleSubmit,
        isUpdate,
        isView,
        emergency_types,
        notificactions_types,
        stations,
        getSelects,
        firefighters,
        vehicles,
        temporal_vehicle,
        setTemporalVehicle,
        selected_vehicles,
        setSelectedVehicles,
        files,
        setFiles,
        customOnChange,
        removeFiles,
        observations_value,
        mark_lat,
        mark_lng,
        pilot,
        item = {},
        me,
        setIsChangeStatusEmergency,
        emergencyTypeId, // injected from mapStateToProps
        dispatch, // Redux dispatch function
    } = props;

    // Calculate allowVehicle based on selected emergency type
    const selectedEmergencyType = emergency_types.find(type => type.value === emergencyTypeId);
    // Default to true if not selected or property missing (safe default for existing types/legacy)
    // But per requirement, we want to hide if it explicitly controls it. 
    // Assuming allow_vehicle comes from backend as boolean.
    // If undefined (e.g. not loaded yet), maybe show it? Or wait.
    // If selectedEmergencyType is undefined, we probably shouldn't hide it yet or it doesn't matter.
    const allowVehicle = selectedEmergencyType ? selectedEmergencyType.allow_vehicle !== false : true;

    const shouldUseSimpleForm = me && me.settings && me.settings.simple_form;
    const isCabinista = me && me.role === ROLE_CABIN_ATTENDANT;

    // Accordion state - All sections expanded by default to show all required fields
    const [sections, setSections] = useState({
        general: true,
        contact: true,
        stations: true,
        vehicles: true,
        patients: true,
        attachments: true,
    });

    const generalRef = useRef(null);
    const contactRef = useRef(null);
    const stationsRef = useRef(null);
    const vehiclesRef = useRef(null);
    const patientsRef = useRef(null);
    const attachmentsRef = useRef(null);

    const toggleSection = (section) => {
        setSections({
            ...sections,
            [section]: !sections[section],
        });
    };

    const renderAccordionHeader = (title, sectionKey, ref) => (
        <div
            ref={ref}
            className="d-flex justify-content-between align-items-center p-3 mb-2 bg-light border rounded cursor-pointer"
            onClick={() => toggleSection(sectionKey)}
            style={{ cursor: 'pointer' }}
        >
            <h4 className="m-0">{title}</h4>
            <i className={`fa fa-chevron-${sections[sectionKey] ? 'up' : 'down'}`}></i>
        </div>
    );


    return (
        <form name="loginForm" onSubmit={handleSubmit}>
            {renderAccordionHeader("Datos Generales", "general", generalRef)}
            <div
                style={{
                    maxHeight: sections.general ? '2000px' : '0',
                    overflow: sections.general ? 'visible' : 'hidden',
                    transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    opacity: sections.general ? 1 : 0
                }}
            >
                <div className="d-flex flex-wrap border p-3 mb-3 rounded">
                    {/* LEFT COLUMN */}
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label htmlFor="emergency_type">
                                Tipo de emergencia <span className="text-danger">*</span>
                            </label>
                            <Field
                                name="emergency_type"
                                label="emergency_type"
                                placeholder="Tipo de emergencia"
                                disabled={isView}
                                options={emergency_types}
                                component={SelectField}
                                className="form-control"
                                formatOptionLabel={(option) => (
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span>{option.label}</span>
                                        {option.allow_vehicle !== false ? (
                                            <span className="badge badge-success badge-pill ml-2" style={{ fontSize: '0.7rem' }}>
                                                Con Vehículo
                                            </span>
                                        ) : (
                                            <span className="badge badge-secondary badge-pill ml-2" style={{ fontSize: '0.7rem' }}>
                                                Sin Vehículo
                                            </span>
                                        )}
                                    </div>
                                )}
                            />
                        </div>

                        {/* Notice Form - Only if NOT Simple/Cabinista */}
                        {!shouldUseSimpleForm && !isCabinista && (
                            <div className="form-group">
                                <label htmlFor="notice_form">
                                    Modo de notificación <span className="text-danger">*</span>
                                </label>
                                <Field
                                    name="notice_form"
                                    label="notice_form"
                                    placeholder="Modo de notificación"
                                    disabled={isView}
                                    options={notificactions_types}
                                    component={SelectField}
                                    className="form-control"
                                />
                            </div>
                        )}

                        {/* Attention Date & Observations */}
                        <div className="form-group">
                            <label htmlFor="attention_date">
                                Fecha y hora de atención {(!shouldUseSimpleForm && !isCabinista) ? <span className="text-danger">*</span> : <small className="text-muted">(Opcional)</small>}
                            </label>
                            {/* Logic: Show if regular user OR if simple/cabinista (always show actually, just validation differs) */}
                            {/* But original code HID it for simple form. New req: Show for cabinista as optional. */}
                            {/* So we render it if !simple OR cabinista */}
                            {(!shouldUseSimpleForm || isCabinista) && (
                                <Field
                                    name="attention_date"
                                    label="attention_date"
                                    component={renderField}
                                    type={"datetime-local"}
                                    className="form-control"
                                />
                            )}
                        </div>

                        {(!shouldUseSimpleForm || isCabinista) && (
                            <React.Fragment>
                                <div className="form-group">
                                    <label htmlFor="observations">
                                        Observaciones {(!shouldUseSimpleForm && !isCabinista) ? <span className="text-danger">*</span> : <small className="text-muted">(Opcional)</small>}
                                    </label>
                                    <Field
                                        name="observations"
                                        label="observations"
                                        component={renderRichTextArea}
                                        className="form-control"
                                        text_value={observations_value}
                                    />
                                </div>
                            </React.Fragment>
                        )}
                    </div>

                    {/* RIGHT COLUMN */}
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label htmlFor="direction">Dirección <span className="text-danger">*</span></label>
                            <Field
                                type="text"
                                name="address"
                                label="address"
                                disabled={isView}
                                component={renderField}
                                validate={validateWhiteSpace}
                                className="form-control"
                            />
                        </div>
                        {(!shouldUseSimpleForm || isCabinista) && (
                            <div className="form-group">
                                <label htmlFor="latlng">Latitud y longitud {(!shouldUseSimpleForm && !isCabinista) ? <span className="text-danger">*</span> : <small className="text-muted">(Opcional)</small>}</label>
                                {isCabinista && (
                                    <div className="d-flex mb-2">
                                        <div className="col-6 pl-0">
                                            <Field
                                                name="latlng.lat"
                                                component={renderField}
                                                type="number"
                                                className="form-control"
                                                placeholder="Latitud"
                                            />
                                        </div>
                                        <div className="col-6 pr-0">
                                            <Field
                                                name="latlng.lng"
                                                component={renderField}
                                                type="number"
                                                className="form-control"
                                                placeholder="Longitud"
                                            />
                                        </div>
                                    </div>
                                )}
                                <Field
                                    name="latlng"
                                    label="latlng"
                                    disabled={isView}
                                    component={renderMap}
                                    mark_lat={mark_lat}
                                    mark_lng={mark_lng}
                                    className="form-control"
                                    heigth={"100%"}
                                    width={"100%"}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {renderAccordionHeader("Persona de Contacto", "contact", contactRef)}
            < div
                style={{
                    maxHeight: sections.contact ? '1500px' : '0',
                    overflow: sections.contact ? 'visible' : 'hidden',
                    transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    opacity: sections.contact ? 1 : 0
                }}
            >
                <div className="border p-3 mb-3 rounded">
                    <FieldArray
                        name="contact_person"
                        component={renderContactPerson}
                        isView={isView}
                    />
                </div>
            </div >

            {renderAccordionHeader("Estaciones y Bomberos", "stations", stationsRef)}
            < div
                style={{
                    maxHeight: sections.stations ? '800px' : '0',
                    overflow: sections.stations ? 'visible' : 'hidden',
                    transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    opacity: sections.stations ? 1 : 0
                }}
            >
                <div className="d-flex flex-wrap border p-3 mb-3 rounded">
                    <div className="col-12 col-md-6 form-group">
                        <label htmlFor="stations">Estaciones <span className="text-danger">*</span></label>
                        <Field
                            name="stations"
                            label="stations"
                            placeholder="Estaciones"
                            disabled={isView}
                            customOnChange={getSelects}
                            isMulti={true}
                            options={stations}
                            component={SelectField}
                            className="form-control"
                        />
                    </div>
                    {!shouldUseSimpleForm && (
                        <div className="col-12 col-md-6 form-group">
                            <label htmlFor="firefighters">
                                Bomberos asistentes {!isCabinista && <span className="text-danger">*</span>}
                            </label>
                            <Field
                                name="firefighters"
                                label="firefighters"
                                placeholder="Bomberos asistentes"
                                disabled={isView || firefighters.length == 0}
                                options={firefighters}
                                isMulti={true}
                                component={SelectField}
                                className="form-control"
                            />
                        </div>
                    )}
                </div>
            </div >

            {
                // Vehicle section: Show only if NOT simple form AND NOT Cabinista AND emergency type allows vehicles
                !shouldUseSimpleForm && !isCabinista && allowVehicle && (
                    <React.Fragment>
                        {renderAccordionHeader("Vehículos", "vehicles", vehiclesRef)}
                        <div
                            style={{
                                maxHeight: sections.vehicles ? '1500px' : '0',
                                overflow: sections.vehicles ? 'visible' : 'hidden',
                                transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
                                opacity: sections.vehicles ? 1 : 0
                            }}
                        >
                            <div className="border p-3 mb-3 rounded">
                                <FieldArray
                                    name="members"
                                    component={renderVehicles}
                                    vehicles={vehicles}
                                    isView={isView}
                                    temporal_vehicle={temporal_vehicle}
                                    setTemporalVehicle={setTemporalVehicle}
                                    selected_vehicles={selected_vehicles}
                                    setSelectedVehicles={setSelectedVehicles}
                                    pilot={pilot}
                                    role={me && me.role}
                                    dispatch={dispatch}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                )
            }
            {
                !shouldUseSimpleForm && (
                    <React.Fragment>
                        {renderAccordionHeader("Pacientes", "patients", patientsRef)}
                        <div
                            style={{
                                maxHeight: sections.patients ? '1500px' : '0',
                                overflow: sections.patients ? 'visible' : 'hidden',
                                transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
                                opacity: sections.patients ? 1 : 0
                            }}
                        >
                            <div className="border p-3 mb-3 rounded">
                                <FieldArray
                                    name="pacients"
                                    component={renderPacients}
                                    isView={isView}
                                />
                            </div>
                        </div>

                        {renderAccordionHeader("Anexos", "attachments", attachmentsRef)}
                        <div
                            style={{
                                maxHeight: sections.attachments ? '2000px' : '0',
                                overflow: sections.attachments ? 'visible' : 'hidden',
                                transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
                                opacity: sections.attachments ? 1 : 0
                            }}
                        >
                            <div className="d-flex flex-wrap border p-3 mb-3 rounded">
                                {files &&
                                    files.map((e, i) => {
                                        const type = typeof e;
                                        return (
                                            <div
                                                key={i}
                                                className="col-12 col-md-6 form-group d-flex flex-column align-items-end"
                                            >
                                                <button
                                                    type="button"
                                                    title="Eliminar"
                                                    className="btn btn-danger"
                                                    onClick={() => removeFiles(i)}
                                                >
                                                    <span
                                                        style={{ fontSize: "20px" }}
                                                        className="material-icons"
                                                    >
                                                        close
                                                    </span>
                                                </button>
                                                {type == "object" ? (
                                                    <img
                                                        alt="fotografia"
                                                        src={
                                                            "../../../../../../.." +
                                                            e.path
                                                        }
                                                        width="200"
                                                        className="rounded mx-auto d-block"
                                                    />
                                                ) : (
                                                    <img
                                                        alt="fotografia"
                                                        src={e}
                                                        width="200"
                                                        className="rounded mx-auto d-block"
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                <div className="col-12 col-md-6 form-group">
                                    <label>Fotografia</label>
                                    <Field
                                        name="photo"
                                        label={"Subir imagen"}
                                        disabled={isView}
                                        customOnChange={customOnChange}
                                        no_show={true}
                                        component={renderFilePicker}
                                        setFile={setFiles}
                                    />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            }

            <div className="col-12 d-flex flex-column flex-md-row justify-content-center">
                <div className="flex-3"></div>
                <div className="flex-1 d-flex flex-column flex-md-row justify-content-center">
                    <Link
                        to={"/emergencies"}
                        className={
                            isView
                                ? "btn btn-secondary px-3 py-3 m-2 w-100"
                                : "btn btn-danger py-3 mt-3 mb-3 w-100"
                        }
                    >
                        {isView ? "Atras" : "Cancelar"}
                    </Link>
                    {!isView && (
                        <button
                            type="submit"
                            className="btn btn-success align-self-center py-3 m-3 w-100"
                            onClick={(event) => {
                                if (isUpdate && item && item.status !== "Resuelta") {
                                    event.preventDefault();
                                    Swal.fire({
                                        title: '¿Desea cambiar el estado de la emergencia a "Resuelta" ?',
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'Si, cambiar!',
                                        cancelButtonText: 'No'
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            setIsChangeStatusEmergency(true);
                                            Swal.fire(
                                                'Cambiado!',
                                                'El estado de la emergencia ha cambiado a resuelta.',
                                                'success'
                                            )
                                        }
                                        // seguir con el submit
                                        handleSubmit();
                                    }
                                    )
                                }
                            }}
                        >
                            {isUpdate ? "Actualizar" : "Crear"}
                        </button>
                    )}
                </div>
            </div>
        </form >
    );
};

const selector = formValueSelector("EmergencyForm"); // select current form
// Decorate form with selected redux form state values
const mapStateToProps = (state) => {
    const firefighterValue = selector(state, "firefighters");
    const stationValue = selector(state, "stations");
    const emergencyTypeId = selector(state, "emergency_type");
    return {
        firefighterValue,
        stationValue,
        emergencyTypeId,
    };
};

// Decorate form with dispatchable actions
const mapDispatchToProps = {
    change,
};

export default reduxForm({
    form: "EmergencyForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate: (data, props) => {
        console.log("VALIDATION - Full data object:", data);
        console.log("VALIDATION - Data keys:", Object.keys(data));
        const errors = {};
        const isSimpleForm = props.me && props.me.settings && props.me.settings.simple_form;
        const isCabinista = props.me && props.me.role === ROLE_CABIN_ATTENDANT;

        // Check if selected emergency type allows vehicles
        const selectedEmergencyType = props.emergency_types && props.emergency_types.find(type => type.value === data.emergency_type);
        const allowVehicle = selectedEmergencyType ? selectedEmergencyType.allow_vehicle !== false : true;

        // Validaciones base para todos los usuarios
        if (!data.address) errors.address = "Este campo es requerido";
        if (!data.emergency_type) errors.emergency_type = "Este campo es requerido";

        // stations is array/multiselect
        if (!data.stations || data.stations.length === 0) errors.stations = "Este campo es requerido";

        // Validaciones solo para NO cabinistas Y NO formulario simple
        if (!isSimpleForm && !isCabinista) {
            const requireVehicles = !props.me.settings || props.me.settings.require_vehicle_assignment !== false;

            // Fecha de atención obligatoria para no cabinistas
            if (!data.attention_date || (typeof data.attention_date === 'string' && data.attention_date.trim() === '')) {
                errors.attention_date = "Este campo es requerido";
            }
            if (!data.notice_form) errors.notice_form = "Este campo es requerido";

            if (!data.firefighters || data.firefighters.length === 0) errors.firefighters = "Este campo es requerido";

            // pacients is array, check if empty
            if (!data.pacients || data.pacients.length === 0) {
                errors.pacients = "Debe agregar al menos un paciente";
            } else {
                const pacientsArrayErrors = [];
                data.pacients.forEach((pacient, index) => {
                    const pacientErrors = {};
                    if (!pacient || !pacient.name) {
                        pacientErrors.name = 'Este campo es requerido';
                    }
                    if (!pacient || !pacient.age) {
                        pacientErrors.age = 'Este campo es requerido';
                    }
                    if (!pacient || !pacient.address) {
                        pacientErrors.address = 'Este campo es requerido';
                    }
                    if (!pacient || !pacient.genre) {
                        pacientErrors.genre = 'Este campo es requerido';
                    }
                    if (!pacient || !pacient.moved_to) {
                        pacientErrors.moved_to = 'Este campo es requerido';
                    }
                    if (Object.keys(pacientErrors).length > 0) {
                        pacientsArrayErrors[index] = pacientErrors;
                    }
                });
                if (pacientsArrayErrors.length > 0) {
                    errors.pacients = pacientsArrayErrors;
                }
            }

            // Validar Contact Person (Opcional, pero si agrega fila debe llenarla)
            if (data.contact_person && data.contact_person.length > 0) {
                const contactArrayErrors = [];
                data.contact_person.forEach((contact, index) => {
                    const contactErrors = {};
                    if (!contact || !contact.name) {
                        contactErrors.name = 'Este campo es requerido';
                    }
                    if (!contact || !contact.phone_number) {
                        contactErrors.phone_number = 'Este campo es requerido';
                    }
                    if (Object.keys(contactErrors).length > 0) {
                        contactArrayErrors[index] = contactErrors;
                    }
                });
                if (contactArrayErrors.length > 0) {
                    errors.contact_person = contactArrayErrors;
                }
            }

            // observations (could be string or check content)
            if (!data.observations || (typeof data.observations === 'string' && data.observations.trim() === '')) {
                errors.observations = "Este campo es requerido";
            }

            // Only require vehicles if emergency type allows them AND user settings require it
            if (requireVehicles && allowVehicle) {
                if (!data.members || data.members.length === 0) errors.members = "Este campo es requerido";
            }

            // Validar Kilometraje en miembros
            if (data.members && data.members.length > 0) {
                const membersArrayErrors = [];
                data.members.forEach((member, index) => {
                    const memberErrors = {};
                    if (member.km_inicial !== undefined && member.km_final !== undefined) {
                        const ini = parseFloat(String(member.km_inicial).replace(/,/g, ""));
                        const fin = parseFloat(String(member.km_final).replace(/,/g, ""));
                        // Only validate when both fields have complete positive values
                        if (!isNaN(ini) && !isNaN(fin) && ini > 0 && fin > 0 && fin < ini) {
                            memberErrors.km_final = "El KM final no debe ser menor a KM inicial";
                        }
                    }
                    if (Object.keys(memberErrors).length > 0) {
                        membersArrayErrors[index] = memberErrors;
                    }
                });
                if (membersArrayErrors.length > 0) {
                    errors.members = membersArrayErrors;
                }
            }
        }
        // Validar latlng para todos los tipos de formulario
        if (!data.latlng || !data.latlng.lat || !data.latlng.lng) {
            errors.latlng = "Debe marcar una ubicación en el mapa";
        }

        return errors;
    },
})(connect(mapStateToProps, mapDispatchToProps)(Form));
